import React, { useEffect, useMemo, useState } from "react";
import DataTable from "../DataTable";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { Button, Stack, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import SwitchButton from "../Switch";
import { shortifyText } from "../../helpers/Common";

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Filter By Name"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
    />
    <Button type="button" onClick={onClear}>
      X
    </Button>
  </>
);

export default function NewsListTable(props) {
  const [filterText, setFilterText] = useState("");
  const [isEnabled, setIsEnabled] = useState(null);
  // const filteredItems = props.data.filter(
  //   (item) =>
  //     item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  // );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText]);

  const onChangeValue = (e, key, key2 = "") => {
    const obj = props?.selectedRow[0];
    key2 ? (obj[key][key2] = e) : (obj[key] = e);
    props?.onSelectedRowsChange({ selectedRows: props?.selectedRow });
  };

  const columns = [
    {
      name: (
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Title
        </Typography>
      ),
      selector: (row) => row.title,
      sortable: true,
      // minWidth: "65%",
      cell: (row, index, column, id) => {
        if (props?.edit && row?._id == props?.selectedRow[0]?._id) {
          return (
            <textarea
              rows="10"
              class="cst-input"
              onChange={(e) => onChangeValue(e.target?.value, "title")}
              // defaultValue={row?.title}
            >
              {row?.title}
            </textarea>
          );
        } else {
          return <p style={{ marginTop: 15 }}>{row.title}</p>;
        }
      },
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 700, width: "100%", textAlign: "center" }}
        >
          Body
        </Typography>
      ),
      selector: (row) => row.body,
      sortable: true,
      cell: (row, index, column, id) => {
        // if (props?.edit) {
        if (props?.edit && row?._id == props?.selectedRow[0]?._id) {
          return (
            <textarea
              rows="10"
              class="cst-input"
              onChange={(e) => onChangeValue(e.target?.value, "body")}
              // defaultValue={row?.body}
            >
              {row?.body}
            </textarea>
          );
        } else {
          return (
            <p style={{ marginTop: 15, textAlign: "center" }}>
              {shortifyText(50, row.body)}
            </p>
          );
        }
      },
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 700, width: "100%", textAlign: "center" }}
        >
          Status
        </Typography>
      ),
      // numeric: false,
      // disablePadding: true,
      selector: (row) => row.status,
      cell: (row, index, column, id) => {
        var switchBool =
          row?.status?.toLowerCase() == "published" ? true : false;

        return (
          <div style={{ width: "100%", textAlign: "center" }}>
            <Switch
              defaultChecked={isEnabled != null ? isEnabled : switchBool}
              onClick={(e) => {
                let switchNewsValue = "published";
                if (e.target.checked) {
                  switchNewsValue = "published";
                } else {
                  switchNewsValue = "draft";
                }
                props.onChangeNewsSwitch(row, switchNewsValue);
              }}
            />
          </div>
        );
      },

      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 700, width: "100%", textAlign: "center" }}
        >
          Actions
        </Typography>
      ),
      sortable: true,
      // selector: (row) => row.isEnabled,
      // selector: (row) => row.action,
      cell: (row) => (
        <div style={{ width: "100%", textAlign: "center" }}>
          <IconButton
            aria-label="delete"
            color="primary"
            onClick={() =>
              props.onNewsDeletePress({
                _id: row._id,
                name: row.title,
              })
            }
          >
            <DeleteRoundedIcon />
          </IconButton>
          <IconButton
            color="primary"
            onClick={() => {
              props.setEditNews(true);
              props.setEditNewsObj({
                ...props.editNewsObj,
                _id: row?._id,
                city_id: row?.city_id,
                user_id: row?.user_id,
                title: row?.title,
                body: row?.body,
                status: row?.status,
                picture: row?.picture,
              });
            }}
          >
            <EditRoundedIcon fontSize="medium" />
          </IconButton>
        </div>
      ),
    },
  ];
  const data = [
    {
      id: 1,
      chapter: "Karachi",
      name: "Beetlejuice",
      company: "IAL",
      title:
        "Asif wins the Legends IAL Saatchi & Saatchi with the best gross ...",
      website: "www.example.com",
      status: true,
    },
    {
      id: 2,
      chapter: "Karachi",
      name: "Beetlejuice",
      company: "IAL",
      title:
        "Asif wins the Legends IAL Saatchi & Saatchi with the best gross ...",
      website: "www.example.com",
      status: true,
    },
    {
      id: 3,
      chapter: "Karachi",
      name: "Beetlejuice",
      company: "IAL",
      title:
        "Asif wins the Legends IAL Saatchi & Saatchi with the best gross ...",
      website: "www.example.com",
      status: true,
    },
    {
      id: 4,
      chapter: "Karachi",
      name: "Beetlejuice",
      company: "IAL",
      title:
        "Asif wins the Legends IAL Saatchi & Saatchi with the best gross ...",
      website: "www.example.com",
      status: true,
    },
  ];

  const conditionalRowStyles = {
    headRow: {
      style: {
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "rgba(0,0,0,0.6)",
        borderRadius: "5px",
      },
    },
  };

  return (
    <DataTable
      columns={columns}
      // data={()=> shortifyText(1300, props.data)}
      data={props.data}
      // selectableRows
      // subHeaderComponent={subHeaderComponentMemo}
      // subHeader
      persistTableHead
      pagination
      paginationServer
      progressPending={props?.progressPending}
      progressComponent={props?.progressComponent}
      paginationTotalRows={10}
      onChangeRowsPerPage={props?.onChangeRowsPerPage}
      customStyles={conditionalRowStyles}
      direction="vertical"
      striped={true}
      clearRow={props?.clearRow}
      onSelectedRowsChange={props?.onSelectedRowsChange}
      onRowDoubleClicked={(row, event) => {
        // if (props.selectedAnnouncementrows?.length == 1) {
        //   props.setEditAnnouncement(!props.editAnnouncement);
        // }
        if (props.selectedRow?.length == 1) {
          props.setEditNews(!props.editNews);
        } else {
          props.setNewsAlert(true);
          setTimeout(() => {
            props.setNewsAlert(false);
          }, 5000);
        }
      }}
    />
  );
}
